var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0833 13.458C11.0833 13.2205 11.1625 13.0622 11.3208 12.9038L15.2792 8.94551C15.5958 8.62884 16.0708 8.62884 16.3875 8.94551C16.7042 9.26217 16.7042 9.73717 16.3875 10.0538L12.4292 14.0122C12.1125 14.3288 11.6375 14.3288 11.3208 14.0122C11.1625 13.8538 11.0833 13.6955 11.0833 13.458Z",
    fill: "#4F2D7F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.0833 5.54167C11.0833 5.30417 11.1625 5.14583 11.3208 4.9875C11.6375 4.67083 12.1125 4.67083 12.4292 4.9875L16.3875 8.94583C16.7042 9.2625 16.7042 9.7375 16.3875 10.0542C16.0708 10.3708 15.5958 10.3708 15.2792 10.0542L11.3208 6.09583C11.1625 5.9375 11.0833 5.77917 11.0833 5.54167Z",
    fill: "#4F2D7F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.375 9.49967C2.375 9.02467 2.69167 8.70801 3.16667 8.70801L15.8333 8.70801C16.3083 8.70801 16.625 9.02467 16.625 9.49967C16.625 9.97467 16.3083 10.2913 15.8333 10.2913L3.16667 10.2913C2.69167 10.2913 2.375 9.97467 2.375 9.49967Z",
    fill: "#4F2D7F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.6b35960b11aa80c934a99719050fb942.svg";
export { ForwardRef as ReactComponent };